'use client';

import { NEXT_ENTITY } from '@common/interfaces/entity';
import { EmployeeDetails } from './EmployeeDetails';
import { EmployeeProvider } from '@components/common-components/Provider/EmployeeProvider';
import { useClientQuery } from '@common';
import { useMsal } from '@azure/msal-react';

export interface IEmployeeProps {
  isSalesRoot?: boolean;
  children: React.ReactNode;
}
export const Employee = ({ children, isSalesRoot = false }: IEmployeeProps) => {
  const { accounts } = useMsal();
  const email = accounts?.[0]?.username ?? null;

  const { data } = useClientQuery(NEXT_ENTITY.EMPLOYEE, { variables: { email }, nextOptions: { revalidate: 60 } });

  return (
    <EmployeeProvider employee={data}>
      <EmployeeDetails isSalesRoot={isSalesRoot}>{children}</EmployeeDetails>
    </EmployeeProvider>
  );
};
